var mariamarne = (function ($) {
  // - efector del formulario de contacto
  var _contactForm7Focus = function (selector = ".form-with-focus") {
    const formsWithAnimatedLabels = document.querySelectorAll(selector);
    const focusedClass = "focused";
    const filledClass = "filled";

    for (const form of formsWithAnimatedLabels) {
      const formControls = form.querySelectorAll(
        '[type="text"], [type="email"], [type="tel"], textarea'
      );
      for (const formControl of formControls) {
        formControl.addEventListener("focus", function () {
          this.closest(".form__group").classList.add(focusedClass);
        });
        formControl.addEventListener("blur", function () {
          if (!this.value || this.value == "") {
            this.closest(".form__group").classList.remove(focusedClass);
            this.closest(".form__group").classList.remove(filledClass);
          } else {
            this.closest(".form__group").classList.remove(focusedClass);
            this.closest(".form__group").classList.add(filledClass);
          }
        });
      }
      form.closest(".wpcf7").addEventListener("mailsent", function () {
        const labels = form.querySelectorAll(".focused");
        const labelsFilled = form.querySelectorAll(".filled");
        for (const label of labels) {
          label.classList.remove(focusedClass);
        }
        for (const labelFilled of labelsFilled) {
          labelFilled.classList.remove(filledClass);
        }
        grecaptcha.reset();
      });
    }
  };

  // - scroll anclas
  var _animatedScroll = function (selector, offset = 75, duration = 3000) {
    $("html, body").animate(
      { scrollTop: $(selector).offset().top - offset },
      duration
    );
    return true;
  };

  var _animateDiv = function (div) {
    $(div).attr("data-anim", "true");
    return true;
  };
  var _desanimateDiv = function (div) {
    $(div).attr("data-anim", "false");
    return true;
  };

  var _quienSoyEffects = function () {
    //Comprobar cual esta activa para animarla
    if ($("#pills-sanitaria").hasClass("active")) {
      mariamarne.animateDiv($("#pills-sanitaria"));
    }
    if ($("#pills-clinica").hasClass("active")) {
      mariamarne.animateDiv($("#pills-clinica"));
    }
    //comprobar cual se ha pulsado, se anima una y se desanima la otra
    $("#pills-sanitaria-tab").on("shown.bs.tab", function (params) {
      mariamarne.desanimateDiv($("#pills-clinica"));
      mariamarne.animateDiv($("#pills-sanitaria"));
    });
    $("#pills-clinica-tab").on("shown.bs.tab", function (params) {
      mariamarne.desanimateDiv($("#pills-sanitaria"));
      mariamarne.animateDiv($("#pills-clinica"));
    });
  };

  return {
    contactForm7Focus: _contactForm7Focus,
    animatedScroll: _animatedScroll,
    animateDiv: _animateDiv,
    desanimateDiv: _desanimateDiv,
    quienSoyEffects: _quienSoyEffects,
  };
})(jQuery);

export default mariamarne;
